module.exports = __webpack_public_path__ + "img/4.53cbfa4e.jpg";